export default __webpack_public_path__ + "static/media/icon_elearning.6bde8bd1.svg";